import { api } from 'app/config/apiConfig';
import i18n from 'app/config/i18Config/i18n';
import { showNotification } from 'app/providers/NotificationsProvider';
import { userActions } from '../model/slice/userSlice';
import { CompleteRegisterUserParams, User } from '../model/types';

export const completeRegistrationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    completeRegistration: builder.mutation<User, { userId: string; userData: CompleteRegisterUserParams }>({
      query: (args) => ({
        url: `/authorization/${args.userId}/complete-registration`,
        method: 'POST',
        body: args.userData,
      }),
      invalidatesTags: ['Users'],
      onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
        try {
          const { data } = await queryFulfilled;

          dispatch(userActions.setUserData(data));
        } catch (error) {
          showNotification('error', i18n.t('Error', { ns: 'common' }), i18n.t('Error when registration user', { ns: 'common' }));
        }
      },
    }),
  }),
});

export const { useCompleteRegistrationMutation } = completeRegistrationApi;
